export enum UploadStatus {
  Success,
  Failed,
  NotUploaded,
  Uploading,
}
